import {paIframeChild} from './paIframeChild';
import {paArray} from './helpers/paArray';

export const paRoute = {
    id: null,
    base: null,
    params: null,
    parts: null,
    hash: null,
    protocol: null,
    init() {
        let href = location.href;
        this.params = location.search.replace('?', '').split('&').reduce(function (s, c) {
            let t = c.split('=');
            s[t[0]] = t[1];
            return s;
        }, {});
        if (typeof this.params.id != 'undefined') {
            this.id = this.params.id;
        }
        if (href.indexOf('#') > -1) {
            href = href.substring(0, href.indexOf('#'))
        }
        if (href.indexOf('https://') > -1) {
            this.protocol = 'https://';
            href = href.substring(8)
        } else if (href.indexOf('http://') > -1) {
            this.protocol = 'http://';
            href = href.substring(7)
        }
        this.parts = href.split('/');
        let index = this.parts.length - 1;
        if (this.parts[index].indexOf('.') > -1) {
            this.parts.splice(index, 1)
        }
        this.hash = window.location.hash.substring(1);
        this.base = this.protocol + paArray.clean(this.parts).join('/');
        if (this.base.substring(this.base.length - 1) !== '/') {
            this.base += '/'
        }

    },
    url(path) {
        return paIframeChild.libSource + path;
    },
    imageUrl(imageName) {
        return paRoute.base + 'img/' + imageName
    },
    set(route) {
        window.location.hash = '#' + route;
    },
    clear(){
        history.pushState("", document.title, window.location.pathname);
    },
    urlify(obj){
        return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/paRoute.js